export default __webpack_public_path__ + "static/media/pioneer6.25b06931.jpeg";